/* AIWA — One-click reorder
   Reads items from a data attribute, adds them to cart, sets cart.note
   from the original order's note + attributes, then redirects to /cart.
   Preserves line-item properties (card message, recipient, etc.).
*/
(function () {
  'use strict';

  var isAr = document.documentElement.lang && document.documentElement.lang.indexOf('ar') === 0;
  var TXT = {
    adding: isAr ? 'جاري الإضافة…' : 'Adding…',
    oos:    isAr ? 'هذه الباقة غير متوفرة اليوم — سنرشّح لك بديلاً عبر واتساب' : 'This arrangement isn\'t available today — we\'ll suggest alternatives on WhatsApp',
    fail:   isAr ? 'تعذّرت الإضافة. جرّب مرة أخرى.' : 'Couldn\'t add. Please try again.'
  };

  function parseItems(btn) {
    try { return JSON.parse(btn.getAttribute('data-reorder') || '[]'); }
    catch (e) { return []; }
  }

  function addToCart(items) {
    return fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ items: items })
    }).then(function (r) {
      if (!r.ok) return r.json().then(function (j) { throw j; });
      return r.json();
    });
  }

  function whatsappFallback(btn) {
    var phone = btn.getAttribute('data-wa-phone') || '971585917091';
    var orderName = btn.getAttribute('data-order-name') || '';
    var msg = isAr
      ? 'مرحباً، أود إعادة طلب ' + orderName + ' — هل يمكنكم اقتراح بديل متوفر اليوم؟'
      : 'Hi! I\'d like to reorder ' + orderName + ' — can you suggest what\'s available today?';
    var url = 'https://wa.me/' + phone + '?text=' + encodeURIComponent(msg);
    window.open(url, '_blank');
  }

  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-reorder]');
    if (!btn) return;
    e.preventDefault();

    var items = parseItems(btn);
    if (!items.length) return;

    var note = btn.getAttribute('data-note') || '';
    var original = btn.textContent;
    btn.disabled = true;
    btn.textContent = TXT.adding;

    addToCart(items)
      .then(function () {
        var redirect = function () { window.location.href = '/cart'; };
        if (note && note.length) {
          fetch('/cart/update.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
            body: JSON.stringify({ note: note })
          }).then(redirect).catch(redirect);
        } else {
          redirect();
        }
      })
      .catch(function (err) {
        btn.disabled = false;
        btn.textContent = original;
        // Likely variant sold out or inventory 0
        var status = err && err.status;
        if (status === 422 || status === 404) {
          if (confirm(TXT.oos)) whatsappFallback(btn);
        } else {
          alert(TXT.fail);
        }
      });
  });
})();
